<template>
  <div class="content">
    <div class="form">
      <div v-if="isNew">
        <div class="hint mt-10" style="color:#404040;opacity:0.7">套餐信息</div>
        \
        <div class="group">
          <div class="item">
            <div class="item-title">科目</div>
            <div class="item-content">
              科目{{ insure.subject_type == 2 ? "二" : "三" }}
            </div>
          </div>
          <div class="item">
            <div class="item-title">套餐时长</div>
            <div class="item-content">
              {{ insure.duration / 60 }}小时（不过补偿套餐费的{{
                insure.claim_rate
              }}%）
            </div>
          </div>
          <div class="item">
            <div class="item-title">精度类型</div>
            <div class="item-content">
              <span
                style="color:#e34736;vertical-align:inherit;display:inline;"
                >{{ insure.is_hp == 0 ? "低精度" : "高精度" }}</span
              >
              <span style="vertical-align:inherit;display:inline;">{{
                insure.is_hp == 0
                  ? "（不可在高精度模式下使用）"
                  : "（不可在低精度模式下使用）"
              }}</span>
            </div>
          </div>
        </div>
        <div class="hint">
          <span>注意</span>
          <label style="font-size:14px;color:#404040"
            >必须使用该手机号对应的账号登录路考仪</label
          >
        </div>
        <div class="item">
          <div class="item-title">被保人手机号</div>
          <div class="item-content">
            <span>{{ insure.mobile }}</span>
          </div>
        </div>
        <div class="item">
          <div class="item-title">验证码</div>
          <div class="item-content">
            <input
              class="input"
              v-model="insure.code"
              placeholder="6位数字"
              maxlength="6"
            />
          </div>
          <span class="get-code" @click="sendCode">{{
            send ? down : "获取验证码"
          }}</span>
        </div>
        <div class="item top">
          <div class="item-title">被保人姓名</div>
          <div class="item-content">
            <input
              class="input"
              v-model="insure.name"
              placeholder="学员姓名，和身份证一致"
            />
          </div>
        </div>
        <div class="item">
          <div class="item-title">身份证号</div>
          <div class="item-content">
            <input
              class="input"
              v-model="insure.id_number"
              placeholder="18位身份证号码"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <div class="item" @click="seleckAddress">
          <div class="item-title">练车城市</div>
          <div class="item-content" style="text-align:right;font-size:.28rem">
            <span v-if="!(province && city)" class="placeholder"
              >请选择练车城市</span
            >
            <span v-else>{{ province }}-{{ city }}</span>
            <img class="right" src="../assets/images/right.png" alt />
          </div>
        </div>
        <div class="item top">
          <div class="item-title">被保人姓名</div>
          <div class="item-content">
            <input
              class="input"
              v-model="insure.name"
              placeholder="学员姓名，和身份证一致"
            />
          </div>
        </div>
        <div class="item">
          <div class="item-title">身份证号</div>
          <div class="item-content">
            <input
              class="input"
              v-model="insure.id_number"
              placeholder="18位身份证号码"
            />
          </div>
        </div>
        <div class="item top">
          <div class="item-title">被保人手机号</div>
          <div class="item-content">
            <input
              class="input"
              v-model="insure.mobile"
              type="tel"
              maxlength="11"
              placeholder="手机号"
            />
          </div>
        </div>
        <div class="item">
          <div class="item-title">验证码</div>
          <div class="item-content">
            <input
              class="input"
              v-model="insure.code"
              placeholder="6位数字"
              maxlength="6"
            />
          </div>
          <span class="get-code" @click="sendCode">{{
            send ? down : "获取验证码"
          }}</span>
        </div>
        <div class="hint">
          <span>注意</span>
          <label
            >手机号必须是被保障学员使用路考仪时绑定的手机号（车轮驾考通账号），否则无法报销。</label
          >
        </div>
        <div class="foote"></div>
      </div>
    </div>
    <div class="foote"></div>
    <div class="footer">
      <div class="weui-cells weui-cells_checkbox">
        <label
          class="weui-cell weui-check__label"
          for="s11"
          style="align-items:baseline"
        >
          <div class="weui-cell__hd">
            <input
              type="checkbox"
              class="weui-check"
              name="checkbox1"
              id="s11"
              @change="changeState($event)"
            />
            <i class="weui-icon-checked"></i>
          </div>
          <div class="weui-cell__bd">
            <p>
              我已确认订单信息，并同意
              <span style="color:#e34736">一旦购买不可退换</span>,
              且知晓本保障将在
              <span style="color:#e34736">购买日期的次日生效</span>
            </p>
          </div>
        </label>
        <label class="weui-cell weui-check__label" for="s12">
          <div class="weui-cell__hd">
            <input
              type="checkbox"
              name="checkbox2"
              class="weui-check"
              id="s12"
              @change="changeState($event)"
            />
            <i class="weui-icon-checked"></i>
          </div>
          <div class="weui-cell__bd">
            <p>
              我已确认
              <span @click.stop="toProtocol"
                >科{{ insure.subject_type == 2 ? "二" : "三" }}保协议</span
              >
              并同意其内容
            </p>
          </div>
        </label>
      </div>
      <div class="pay">
        <span class="pay-amount">
          总价：
          <span>￥{{ insure.amount }}</span>
        </span>
        <button class="pay-btn" @click="add"></button>
      </div>
    </div>
    <div v-if="showDialog" class="dialog-item">
      <dialog-item :value="massage"></dialog-item>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import dialogItem from "@/components/dialog";
import _wx from "../../static/js/chelun-wx-1.1.js";
import weui from "weui.js";
import {
  getCities,
  insureAdd,
  insureOrderAdd,
  sendCode,
  pay,
  sendCodeCheck
} from "@/http/api";
import { identityCodeValid } from "../util/idc";
import { payUrl, hostUrl } from "../http/env.js";
const isMobileReg = /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(16[0-9])|(17[0-9])|(18[0-9])|191|193|195|198|199|(147))\d{8}$/;
let interval;
export default {
  props: ["openid", "pay_type"],
  name: "insure",
  components: {
    "dialog-item": dialogItem
  },
  data() {
    return {
      isNew: false,
      showDialog: false,
      insure: {
        soft_sn: sessionStorage.soft_sn,
        coach_id: sessionStorage.coach_id,
        subject_type: sessionStorage.subject_type,
        duration: sessionStorage.duration,
        is_hp: sessionStorage.is_hp,
        mobile: sessionStorage.mobile || "",
        amount: sessionStorage.amount,
        type: sessionStorage.insure_type || "",
        group_id: sessionStorage.group_id || "",
        claim_rate: sessionStorage.claim_rate || "",
        type: sessionStorage.type || ""
      },
      province: "",
      city: "",
      paying: false,
      send: false,
      down: 60,
      check_1: false,
      check_2: false,
      group_id: ""
    };
  },
  mounted() {
    document.title = `购买科${
      sessionStorage.subject_type == 2 ? "二" : "三"
    }保`;
    if (sessionStorage.mobile) {
      this.isNew = true;
    } else {
      this.isNew = false;
    }
    this.getCities();
  },
  methods: {
    changeState(e) {
      let name = e.target.name;
      if (name == "checkbox1") {
        this.check_1 = e.target.checked;
      }
      if (name == "checkbox2") {
        this.check_2 = e.target.checked;
      }
    },
    toProtocol() {
      this.$router.push({
        path: "/protocol"
      });
    },
    showDia(massage) {
      this.showDialog = true;
      this.massage = massage;
      setTimeout(() => {
        this.showDialog = false;
        this.massage = "";
      }, 1500);
    },
    getCities() {
      getCities({}).then(res => {
        this.initCity(res.data);
      });
    },
    initCity(city) {
      let cities = [];
      city.forEach((item, index) => {
        cities[index] = {};
        cities[index].label = item.name;
        cities[index].value = item.id;
        let children = [];
        item.list.forEach((e, i) => {
          children[i] = {};
          children[i].label = e.name;
          children[i].value = e.id;
        });
        cities[index].children = children;
      });
      this.cities = cities;
    },
    seleckAddress() {
      weui.picker(this.cities, {
        onChange: result => {},
        onConfirm: result => {
          console.log(result);
          this.province = result[0].label;
          this.city = result[1].label;
          this.province_id = result[0].value;
          this.city_id = result[1].value;
        }
      });
    },
    add() {
      if (!this.isNew && (!this.province || !this.city)) {
        this.showDia("请选择城市");
      } else if (!this.insure.name) {
        this.showDia("姓名不能为空");
      } else if (
        !this.insure.id_number ||
        !identityCodeValid(this.insure.id_number)
      ) {
        this.showDia("请填写正确的身份证号");
      } else if (
        !this.isNew &&
        (!this.insure.mobile || !isMobileReg.test(this.insure.mobile))
      ) {
        this.showDia("请填写正确的手机号");
      } else if (!this.insure.code) {
        this.showDia("验证码不能为空");
      } else if (!this.check_1) {
        this.showDia("请勾选并确认订单信息");
      } else if (!this.check_2) {
        this.showDia("请确认保障协议内容");
      } else {
        let date_dirth = this.insure.id_number.slice(6, -4);
        date_dirth = new Date(
          date_dirth.slice(0, 4) +
            "/" +
            date_dirth.slice(4, 6) +
            "/" +
            date_dirth.slice(-2)
        ).getTime();
        console.log(date_dirth);
        let date = new Date().getTime();
        console.log(date - date_dirth);
        if (
          567993600000 > date - date_dirth ||
          date - date_dirth > 2082758400000
        ) {
          this.showDia("购保学员须在18-65周岁之间");
          return;
        }
        if (this.paying) {
          return;
        }
        this.paying = true;
        if (this.pay_type == "insure") {
          insureAdd({
            name: this.insure.name,
            id_number: this.insure.id_number,
            mobile: this.insure.mobile,
            province: this.province,
            city: this.city,
            code: this.insure.code
          })
            .then(res => {
              console.log(res);
              if (res.code === 0) {
                this.pay(res.data);
              } else {
                this.showDia(res.msg);
              }
              setTimeout(() => {
                this.paying = false;
              }, 3000);
            })
            .catch(err => {
              this.paying = false;
              this.showDia("请求失败，请检查网络后重试");
            });
        } else if (this.pay_type == "insureOrder") {
          sendCodeCheck({
            mobile: this.insure.mobile,
            code: this.insure.code
          })
            .then(res => {
              if (res.code === 0) {
                this.insureOrderAdd();
              } else {
                this.paying = false;
                this.showDia(res.msg);
              }
            })
            .catch(err => {
              this.paying = false;
              this.showDia("请求失败，请检查网络后重试");
            });
        }
      }
    },
    insureOrderAdd() {
      insureOrderAdd({
        name: this.insure.name,
        id_number: this.insure.id_number,
        mobile: this.insure.mobile,
        province_id: this.province_id,
        city_id: this.city_id,
        soft_sn: this.insure.soft_sn,
        coach_id: this.insure.coach_id,
        open_id: this.openid,
        subject_type: this.insure.subject_type,
        is_hp: this.insure.subject_type == 2 ? 0 : this.insure.is_hp,
        duration: this.insure.duration,
        claim_rate: this.insure.claim_rate,
        type: this.insure.type
      })
        .then(res => {
          console.log(res);
          if (res.code === 0) {
            // this.group_id = res.data.group_id;
            this.pay(res.data);
          } else {
            this.showDia(res.msg);
          }
          setTimeout(() => {
            this.paying = false;
          }, 3000);
        })
        .catch(err => {
          this.paying = false;
          this.showDia("请求失败，请检查网络后重试");
        });
    },
    pay(pay_data) {
      let channel = _wx.isWx ? "weixin_mp" : "alipay";
      let callbackUrl;
      if (+this.group_id) {
        callbackUrl = `${hostUrl}/frontend/insure-group?info=${this.group_id},${this.openid}`;
      } else {
        callbackUrl = `${hostUrl}/frontend/insure-order-result?info=${encodeURIComponent(
          this.insure.id_number +
            "," +
            this.insure.name +
            "," +
            this.insure.subject_type
        )}`;
      }
      let url = `${payUrl}/api.php?c=order&v=pay2&serial_number=${
        pay_data.serial_number
      }&channel=${channel}&openid=${
        this.openid
      }&callback_url=${encodeURIComponent(callbackUrl)}`;
      console.log(url);
      pay({
        c: "order",
        v: "pay2",
        serial_number: pay_data.serial_number,
        channel: channel,
        openid: this.openid,
        callback_url: encodeURIComponent(callbackUrl)
      })
        .then(res => {
          if (_wx.isWx) {
            console.log(res.data.order_param);
            let path = "https://xch5.chelun.com/2017/superCoach/pay_wx.html";
            let i,
              url = "";
            for (i in res.data.order_param)
              url += "&" + i + "=" + res.data.order_param[i];
            window.location.href = path + url.replace(/./, "?");
          } else {
            window.location.href = res.data.url;
          }
        })
        .catch(err => {
          console.log(err);
          this.paying = false;
          this.showDia("请求失败，请检查网络后重试");
        });
    },
    sendCode() {
      this.insure.mobile = this.insure.mobile.trim();
      if (!this.insure.mobile || !isMobileReg.test(this.insure.mobile)) {
        this.showDia("请填写正确的手机号");
        return;
      }
      sendCode({ mobile: this.insure.mobile }).then(res => {
        console.log(res);
        if (res.code === 0) {
          this.showDia("发送成功");
          this.send = true;
          this.down = 60;
          interval = setInterval(() => {
            if (this.down > 0) {
              this.down--;
            } else {
              clearInterval(interval);
              this.send = false;
              this.down = 60;
            }
          }, 1000);
        } else {
          this.showDia(res.msg);
        }
      });
    }
  },
  destroyed() {
    clearInterval(interval);
    this.send = false;
    this.down = 60;
  }
};
</script>
<style>
.weui-picker__content .weui-picker__item {
  font-size: 0.34rem;
}
</style>
<style lang="scss" scoped>
.content {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 750px;
  margin: auto;
  background: #f5f6f7;

  .form {
    .top {
      margin-top: 0.2rem;
    }
    .item {
      background: #fff;
      border-bottom: 1px solid #eee;
      padding: 0 0.3rem;
      height: 1.1rem;
      display: -webkit-flex;
      display: flex;
      align-items: center;
      .item-title {
        font-size: 0.3rem;
        width: 2.1rem;
        text-align: left;
      }
      .item-content {
        font-size: 0.28rem;
        flex: 1;
        // text-align: right;
        span {
          display: inline-block;
          vertical-align: middle;
          color: rgba(51, 51, 51, 1);
          // margin-right: 0.08rem;
        }
        .placeholder {
          color: rgba(51, 51, 51, 0.5);
        }
        .right {
          display: inline-block;
          width: 0.14rem;
          height: 0.28rem;
          vertical-align: middle;
        }
        .input {
          width: 100%;
          color: #333;
          outline: none;
          font-size: 0.28rem;
        }
      }
      .get-code {
        font-size: 0.28rem;
        color: #4a3ce4;
        margin-left: 0.2rem;
        display: inline-block;
        text-align: center;
        min-width: 1.4rem;
      }
      .textarea {
        width: 100%;
        outline: none;
        font-size: 0.28rem;
      }
    }
  }
  .hint {
    padding: 0.1rem 0.3rem;
    color: rgba(65, 65, 65, 0.6);
    font-size: 0.28rem;
    color: #e34736;
    span {
      width: 0.84rem;
      height: 0.34rem;
      border: 0.02rem solid #e34736;
      border-radius: 0.04rem;
      color: #e34736;
      display: inline-block;
      text-align: center;
      line-height: 0.3rem;
      box-sizing: border-box;
    }
  }
  .foote {
    margin-top: 0.3rem;
    height: 3.6rem;
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 750px;
    margin: auto;
    background: #fff;
    .pay {
      padding-left: 0.3rem;
      display: flex;
      align-items: center;
      height: 1rem;
      .pay-amount {
        font-weight: 500;
        font-size: 0.32rem;
        color: #29113e;
        flex: 1;
        span {
          font-size: 0.28rem;
          &:nth-child(2) {
            font-size: 0.24rem;
            text-decoration: line-through;
            margin-left: 0.2rem;
            font-weight: 400;
            color: rgba(41, 17, 62, 0.7);
          }
        }
      }
      .pay-btn {
        background: url(http://picture.eclicks.cn/kaojiazhao/public/rem/insure/3_zhifu.png)
          no-repeat;
        background-size: 100% auto;
        height: 100%;
        width: 2.6rem;
        font-size: 0.34rem;
        font-weight: 500;
      }
    }
  }

  .group {
    border-bottom: 1px solid #eee;
    background-color: #fff;
    padding: 0.12rem 0 0.11rem;
    margin-bottom: 0.2rem;
    .item {
      margin: 0.11rem 0;
      border-bottom: none;
      height: 0.4rem;
      line-height: 0.28rem;

      &-content {
        color: #333333;
      }
    }
  }

  .mt-10 {
    margin-top: 0.14rem;
  }
}
.weui-cells {
  margin-top: 0;
}
.weui-cell__bd {
  font-size: 0.28rem;
  color: #414141;
  p {
    span {
      color: #4a3ce4;
    }
  }
}
.protocol {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
}
.weui-icon-checked {
  font-size: 0.34rem;
}

.weui-cells_checkbox .weui-icon-checked:before {
  content: "\EA01";
  color: #666;
  font-size: 0.34rem;
  font-weight: 700;
  display: block;
}
.weui-cells_checkbox .weui-check:checked + .weui-icon-checked:before {
  content: "\EA06";
  font-size: 0.34rem;
  color: #4a3ce4;
}
</style>



// WEBPACK FOOTER //
// src/components/insurePay.vue